// Content for /bhutan-tour-packages-from-india
// Used by the React page AND by scripts/prerender.mjs — edit here only.
// Keep this file free of imports (the prerender script loads it directly).

export const INDIA_PATH = "/bhutan-tour-packages-from-india";

export const INDIA_SEO = {
  title: "Bhutan Tour Packages from India · Special Rates for Indian Guests",
  description:
    "Private Bhutan tour packages for Indian travellers from a licensed Paro operator. No visa needed, SDF ₹1,200/night, travel by road via Phuentsholing or fly to Paro. WhatsApp us for special Indian rates.",
};

export const INDIA_WA_MESSAGE =
  "Hi Planet Air Adventure, I'm travelling from India and would like your special rates for a Bhutan trip.";

export const INDIA_HERO = {
  overline: "For Indian travellers",
  title: "Bhutan tour packages from India",
  intro:
    "Private Bhutan holidays planned by our own team in Paro — permits, SDF, guide, vehicle and hotels handled for you. No visa, no hassle. Message us on WhatsApp for our special rates for Indian guests.",
};

export const INDIA_FACTS = [
  ["No visa", "Entry permit only"],
  ["Passport or Voter ID", "Either one is accepted"],
  ["₹1,200 / night", "SDF per adult"],
  ["24 hours", "Our reply time"],
];

export const INDIA_ROUTES = [
  {
    title: "By road via Phuentsholing",
    body:
      "Cross from Jaigaon in West Bengal into Phuentsholing, Bhutan's main border town. The nearest airport on the Indian side is Bagdogra, and the nearest railway stations are Hasimara and New Jalpaiguri (NJP). From Phuentsholing it is a scenic drive up to Thimphu and Paro.",
  },
  {
    title: "By air into Paro",
    body:
      "Drukair and Bhutan Airlines fly into Paro from Delhi, Kolkata, Bagdogra and Guwahati. We book your tickets along with your tour, so flights, permits and pick-up all line up.",
  },
];

export const INDIA_INCLUDES = [
  "Entry permit and route permits arranged by us",
  "Licensed Bhutanese guide throughout",
  "Private vehicle with an experienced driver",
  "Hotels and meals to suit your budget",
  "Itinerary planned around your dates and pace",
  "Drukair and Bhutan Airlines tickets on request",
];

export const INDIA_DOCUMENTS = [
  "Adults: a valid Indian passport (at least 6 months' validity) or an original Voter ID card",
  "Children under 18: a passport or a birth certificate",
  "Recent passport-size photographs",
  "Aadhaar, PAN card and driving licence are not accepted for entry",
];

export const INDIA_SDF = [
  "Adults: ₹1,200 per person per night",
  "Children aged 6–12: ₹600 per night",
  "Children under 6: no SDF",
];

export const INDIA_FAQS = [
  {
    q: "Do Indians need a visa for Bhutan?",
    a: "No. Indian nationals don't need a visa. You get a free entry permit, either online before you travel or on arrival at Phuentsholing or Paro airport. We prepare the permit paperwork for our guests.",
  },
  {
    q: "Which ID do Indian travellers need to enter Bhutan?",
    a: "Adults need either a valid Indian passport with at least six months' validity or an original Voter ID card. Children under 18 can use a passport or a birth certificate. Aadhaar, PAN cards and driving licences are not accepted.",
  },
  {
    q: "How much is the SDF for Indian tourists?",
    a: "Indian nationals pay a Sustainable Development Fee of ₹1,200 per adult per night. Children aged 6 to 12 pay ₹600 per night, and children under 6 pay nothing.",
  },
  {
    q: "Can I travel to Bhutan from India by road?",
    a: "Yes. Most Indian guests enter by road from Jaigaon (West Bengal) into Phuentsholing. Bagdogra is the nearest airport and Hasimara or New Jalpaiguri the nearest railway stations. From Phuentsholing we drive you up to Thimphu and Paro.",
  },
  {
    q: "Which Indian cities have flights to Paro?",
    a: "Drukair and Bhutan Airlines fly to Paro from Delhi, Kolkata, Bagdogra and Guwahati. We can book your flights together with your tour package.",
  },
  {
    q: "Can I visit Punakha and other places beyond Thimphu and Paro?",
    a: "Yes. The entry permit covers Thimphu and Paro; for places like Punakha, Gangtey (Phobjikha) and Bumthang you need a route permit, which is issued in Thimphu. We arrange it as part of your trip.",
  },
  {
    q: "How much does a Bhutan tour package from India cost?",
    a: "It depends on your dates, number of nights, hotel category and group size. We offer special rates for Indian guests — send us your travel dates on WhatsApp and we'll reply with a personalised quote within 24 hours.",
  },
];
